<template>
  <el-dialog custom-class="list-dialog" :title="seedname" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-col :span="10">
          <el-select v-model="minyear" placeholder="" style="width:80px" size="mini">
            <el-option
              v-for="item in getYearList()"
              :key="item+''"
              :label="item+''"
              :value="item+''">
            </el-option>
          </el-select>
          <el-select v-model="minmonth" placeholder="" style="width:65px" size="mini">
            <el-option
              v-for="item in monthList"
              :key="item+''"
              :label="item+''"
              :value="item+''">
            </el-option>
          </el-select>
          <!--至-->
          <!--<el-select v-model="maxyear" placeholder="" style="width:80px">-->
          <!--<el-option-->
          <!--v-for="item in getYearList()"-->
          <!--:key="item+''"-->
          <!--:label="item+''"-->
          <!--:value="item+''">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<el-select v-model="maxmonth" placeholder="" style="width:65px">-->
          <!--<el-option-->
          <!--v-for="item in monthList"-->
          <!--:key="item+''"-->
          <!--:label="item+''"-->
          <!--:value="item+''">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <el-select class="Select" v-model="cangkucode" placeholder="请选择仓库" style="width:130px" size="mini" v-if="showOrderDetail" @change="search">
            <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                       :label="item.cangkuname"
                       :value="item.cangkucode">
            </el-option>
          </el-select>
          <!--<CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindTree" :isShowCheckBox="false"-->
                      <!--:treeHeight="400" :treeWidth="400" :searchText="seedname" :canDelete="false" :inputSize="'mini'"-->
                      <!--style="width:200px;display: inline-block;" @check="checktree"></CommonTree>-->
        </el-col>
        <el-col :span="4" v-if="filltemplate==80">
          <el-checkbox v-model="checkXL" size="mini">查询全系列库存</el-checkbox>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search" size="mini">搜索</el-button>
          <el-button type="primary" icon="el-icon-download" @click="exportExcel()" size="mini">导出
          </el-button>
          <el-button type="primary" @click="zhixiaolen()" size="mini">滞销光度</el-button>
          <el-button type="primary" @click="zhinengstock()" size="mini">智能库存</el-button>
          <el-button type="primary" @click="print1" v-if="false">打印库存表</el-button>
          <!--<el-button type="primary" v-if="defaulttabname=='maxstore'" @click="initnum">一键补货</el-button>-->
        </el-col>
        <el-col :span="7" v-if="tip()&&filltemplate!=40&&filltemplate!=80">
          <span>球：</span>
          <el-input style="width:70px;" v-model="Y" @change="change1">
          </el-input>
          <span>-</span>
          <span>柱：</span>
          <el-input style="width:70px;" v-model="X" @change="change2">
          </el-input>
          <el-select v-model="RorL" placeholder="" style="width:75px" @change="initStoreDetail">
            <el-option label="R/L" value=""></el-option>
            <el-option label="R" value="R"></el-option>
            <el-option label="L" value="L"></el-option>
          </el-select>
        </el-col>
        <el-col :span="7" v-if="tip()&&filltemplate==80">
          <span>型号：</span>
          <el-input style="width:70px;" v-model="Y" @change="change1">
          </el-input>
          <span>-</span>
          <span>规格：</span>
          <el-input style="width:70px;" v-model="X" @change="change2">
          </el-input>
        </el-col>
      </el-col>
      <CstagreementMachiningEdit v-if="true" ref="machiningedit"></CstagreementMachiningEdit>
      <CstagreementMachiningEdit v-if="true" ref="machiningeditcopy"></CstagreementMachiningEdit>
      <CstagreementEdit v-if="true" ref="DataContactEditCopy" @ceshi="ceshi"></CstagreementEdit>
      <CstagreementEdit v-if="true" ref="DataContactEdit"></CstagreementEdit>
      <AllocationDetail v-if="true" ref="AllocationDetail"></AllocationDetail>
      <MakeInventorySwitch v-if="true" ref="MakeInventoryEdit"></MakeInventorySwitch>
      <StorageBadOut v-if="true" ref="StorageBadOut"></StorageBadOut>
      <BuyorderDetail ref="BuyorderDetail" @bindGrid="bindGrid"></BuyorderDetail>
      <BaoSunDetail ref="BaoSunDetail"></BaoSunDetail>
    </div>
    <el-col :span="24">
      <el-col :span="21">
        <div v-if="showtab==1&&showerweitable&&filltemplate!=40"  :style="showyinxing?'width:30%;float:left;':''" ref="print1">
          <comment :is="currentcomponent" v-if="showtab==1&&showerweitable" ref="referweibiao" :showewbbgcolor="defaulttabname=='subtractnum'||defaulttabname=='canuse'"
                   :initContent="initContent"
                   :cutHeight="80"></comment>
        </div>
        <div ref="print1" v-show="showtab==1&&filltemplate==40" :style="showyinxing?'width:30%;float:left;':''">
          <el-table
            :data="tableData"
            :height="tableHeight(118)"
            size="mini"
            border
            style="width: 100%;">
            <el-table-column label="库存" align="left" header-align="center" width="70" @click="scancode">
              <template slot-scope="scope">
                {{scope.row.subtractnum == 0 ? "" : scope.row.subtractnum}}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="showtab==1&&showerweitable&&showyinxing" style="width:68%;float:left;padding-left: 10px">
          <div style="text-align:right;font-size:12px;"><span>总数：{{yinxintotalnumber}}</span></div>
          <el-table :data="tableDataYinxin"
            :height="tableHeight(118)" :row-class-name="tableRowClassName"
            size="mini"
            border style="width: 100%;">
            <el-table-column label="厂家" align="left" header-align="center" width="105" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.certorg }}
              </template>
            </el-table-column>
            <el-table-column label="注册证号" align="left" header-align="center" width="135" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.certno }}
              </template>
            </el-table-column>
            <el-table-column label="球镜" align="left" header-align="center" width="75">
              <template slot-scope="scope">
                {{ getPackagesize(scope.row.packagesize,'Y') }}
              </template>
            </el-table-column>
            <el-table-column label="柱镜" align="left" header-align="center" width="75">
            <template slot-scope="scope">
              {{ getPackagesize(scope.row.packagesize,'X') }}
            </template>
          </el-table-column>
            <el-table-column label="批次号" align="left" header-align="center" width="115" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                {{ scope.row.batchno }}
              </template>
            </el-table-column>
            <el-table-column label="失效日期" align="left" header-align="center" width="105">
              <template slot-scope="scope">
                {{ scope.row.endtime?(scope.row.endtime.split(' ')[0]):''}}
              </template>
            </el-table-column>
            <el-table-column label="数量" align="right" header-align="center" width="70">
              <template slot-scope="scope">
                {{scope.row.totalnumber == 0 ? "" : scope.row.totalnumber}}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="showzuoyoutable&&filltemplate!=40&&filltemplate!=80" ref="print1">
          <el-col :span="2" style="text-align: left" v-if="showtab==1">右眼：</el-col>
          <el-col :span="6">
            <comment :is="currentcomponent" v-if="showtab==1" ref="referweibiaoright" :initContent="initContentRight"
                     :cutHeight="150"></comment>
          </el-col>
          <el-col :span="2" style="text-align: left" v-if="showtab==1">左眼：</el-col>
          <el-col :span="6">
            <comment :is="currentcomponent" v-if="showtab==1" ref="referweibiaoleft" :initContent="initContentLeft"
                     :cutHeight="150"></comment>
          </el-col>
        </div>
        <el-table
          :data="deliverData" v-if="showtab==4"
          :height="tableHeight(118)"
          size="mini"
          border
          style="width: 100%;">
          <el-table-column label="门店" align="left" header-align="center" prop="customername" width="300"
                           :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="订单号" align="center" header-align="center" prop="erpserial">
          </el-table-column>
          <el-table-column label="日期" align="center" header-align="center" prop="htqd">
          </el-table-column>
          <!--<el-table-column label="编码" align="center" header-align="center" prop="seedcode">-->
          <!--</el-table-column>-->
          <el-table-column label="球镜" align="left" header-align="center" width="75">
            <template slot-scope="scope">
              {{ getPackagesize(scope.row.packagesize,'Y') }}
            </template>
          </el-table-column>
          <el-table-column label="柱镜" align="left" header-align="center" width="75">
            <template slot-scope="scope">
              {{ getPackagesize(scope.row.packagesize,'X') }}
            </template>
          </el-table-column>

          <el-table-column label="数量" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.deliverying == 0 ? "" : scope.row.deliverying}}
            </template>
          </el-table-column>

        </el-table>
        <el-table
          :data="tableData" v-if="showtab==3"
          :height="tableHeight(118)"
          size="mini"
          show-summary
          border
          :summary-method="getSummaries"
          style="width: 100%;">
          <el-table-column label="编码" align="center" header-align="center">
            <template slot-scope="scope">
              {{ scope.row.seedcode }}
            </template>
          </el-table-column>
          <el-table-column label="球镜" align="left" header-align="center" width="75">
            <template slot-scope="scope">
              {{ getPackagesize(scope.row.packagesize,'Y') }}
            </template>
          </el-table-column>
          <el-table-column label="柱镜" align="left" header-align="center" width="75">
            <template slot-scope="scope">
              {{ getPackagesize(scope.row.packagesize,'X') }}
            </template>
          </el-table-column>
          <el-table-column label="期初" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.qichu == 0 ? "" :scope.row.qichu}}
            </template>
          </el-table-column>
          <el-table-column label="入库" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.debitnum == 0 ? "" : scope.row.debitnum}}
            </template>
          </el-table-column>
          <el-table-column label="出库" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.creditnum == 0 ? "" : scope.row.creditnum}}
            </template>
          </el-table-column>
          <el-table-column label="结存" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.subtractnum == 0 ? "" : scope.row.subtractnum}}
            </template>
          </el-table-column>
          <el-table-column label="待发货" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.deliverying == 0 ? "" : scope.row.deliverying}}
            </template>
          </el-table-column>
          <el-table-column label="可用量" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.canuse == 0 ? "" : scope.row.canuse}}
            </template>
          </el-table-column>
          <el-table-column label="调拨中" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.transfernum == 0 ? "" : scope.row.transfernum}}
            </template>
          </el-table-column>
          <el-table-column label="最小库存" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.setminstore == 0 ? "" : scope.row.setminstore}}
            </template>
          </el-table-column>
          <el-table-column label="预警" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.minstore == 0 ? "" : scope.row.minstore}}
            </template>
          </el-table-column>
          <el-table-column label="最大库存" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.setmaxstore == 0 ? "" : scope.row.setmaxstore}}
            </template>
          </el-table-column>
          <el-table-column label="需补货" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.maxstore == 0 ? "" : scope.row.maxstore}}
            </template>
          </el-table-column>
          <el-table-column label="超库存" align="right" header-align="center" width="80">
            <template slot-scope="scope">
              {{scope.row.surplus == 0 ? "" : scope.row.surplus}}
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="tableData2" v-show="tip()"  :height="tableHeight(118)" size="mini" border style="width: 100%;">
          <el-table-column label="日期" align="center" header-align="center" width="150" prop="accdate"></el-table-column>
          <el-table-column label="订单号" align="center" header-align="center" width="150" prop="ordernum">
            <template slot-scope="scope">
                  <span @click="lookorder(scope.row)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.ordernum?scope.row.ordernum:scope.row.erpserial}}
                  </span>
            </template>
          </el-table-column>
          <el-table-column label="单据类型" align="left" header-align="center" width="100" prop="ordername">
            <template slot-scope="scope">
                  <span @click="lookorder(scope.row)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.ordername?scope.row.ordername:scope.row.erpformname}}
                  </span>
            </template>
          </el-table-column>
          <el-table-column label="批次号" v-if="showyinxing" align="left" header-align="center" width="135" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ scope.row.batchno }}
            </template>
          </el-table-column>
          <el-table-column label="失效日期" v-if="showyinxing" align="left" header-align="center" width="105">
            <template slot-scope="scope">
              {{ scope.row.endtime?scope.row.endtime.split(' ')[0]:''}}
            </template>
          </el-table-column>
          <el-table-column label="球镜" align="left" header-align="center" width="75">
            <template slot-scope="scope">
              {{ getPackagesize(scope.row.packagesize,'Y') }}
            </template>
          </el-table-column>
          <el-table-column label="柱镜" align="left" header-align="center" width="75">
            <template slot-scope="scope">
              {{ getPackagesize(scope.row.packagesize,'X') }}
            </template>
          </el-table-column>
          <el-table-column label="入库" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.debitnum == 0 ? "" : scope.row.debitnum}}
            </template>
          </el-table-column>
          <el-table-column label="出库" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.creditnum == 0 ? "" : scope.row.creditnum}}
            </template>
          </el-table-column>
          <el-table-column label="结存" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.subtractnum == 0 ? "" : scope.row.subtractnum}}
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="3">
        <el-tabs tab-position="right" @tab-click="tabClick" v-model="defaulttabname" v-if="showOrderDetail">
          <el-tab-pane label="库存量" name="subtractnum"></el-tab-pane>
          <el-tab-pane label="出入库明细" name="storedetail"></el-tab-pane>
          <el-tab-pane label="汇总" name="sublist"></el-tab-pane>
          <!--<el-tab-pane label="入库量" name="debitnum" v-if="showerb"></el-tab-pane>-->
          <el-tab-pane label="待发货" name="deliverying" v-if="showerb&&showNowmonth"></el-tab-pane>
          <el-tab-pane label="可用量" name="canuse" v-if="showerb&&showNowmonth"></el-tab-pane>
          <el-tab-pane label="调拨中" name="transfernum" v-if="showerb&&showNowmonth"></el-tab-pane>
          <el-tab-pane label="采购中" name="buynum" v-if="showerb&&showNowmonth"></el-tab-pane>
          <el-tab-pane label="最小库存" name="setminstore" v-if="showerb&&showNowmonth"></el-tab-pane>
          <el-tab-pane label="预警" name="minstore" v-if="showerb&&showNowmonth"></el-tab-pane>
          <el-tab-pane label="最大库存" name="setmaxstore" v-if="showerb&&showNowmonth"></el-tab-pane>
          <el-tab-pane label="需补货" name="maxstore" v-if="showerb&&showNowmonth"></el-tab-pane>
          <el-tab-pane label="超库存" name="surplus" v-if="showerb&&showNowmonth"></el-tab-pane>
          <el-tab-pane label="已销售" name="hassale" v-if="showerb"></el-tab-pane>
        </el-tabs>
      </el-col>
      <UniqueCode ref="UniqueCode"></UniqueCode>
      <zhixiaolen ref="zhixiaolen" @afterSet="search"></zhixiaolen>
      <zhinengstock ref="zhinengstock" @afterSet="search"></zhinengstock>
    </el-col>

  </el-dialog>

</template>

<script>


  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import TwoDimensionalView from '@/components/set/goodsprice/TwoDimensionalView';
  import glassFrameView from '@/components/set/goodsprice/glassFrameView';
  import {formatTimeToStr} from '@/plugin/Date';
  import {getGoodsListWithStoreDetail, getStoreFormList, stayDelivar, getGoodsNeedBuy} from '@/api/set/jxcresultstore';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import CstagreementMachiningEdit from '../cstagreement/CstagreementMachiningEdit';
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import AllocationDetail from '@/components/warehouse/AllocationDetail';
  import BuyorderDetail from '@/components/testorder/buyagreement/BuyorderDetail'
  import MakeInventorySwitch from '@/components/warehouse/MakeInventorySwitch'
  import StorageBadOut from '@/components/warehouse/StorageBadOut'
  import UniqueCode from '@/components/testorder/warehouse/UniqueCode'
  import zhixiaolen from '@/components/testorder/warehouse/zhixiaolen'
  import zhinengstock from '@/components/testorder/warehouse/zhinengstock'
  import BaoSunDetail from '@/components/testorder/cstagreement/BaoSunDetail';
  import {exportExcel} from '@/api/file'
  import {listData,listBarchnoSub} from '@/api/set/jxcstoregoodsbarcode';


  export default {
    name: "StorageView",
    data() {
      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        currentcomponent: "",
        showerb: true,
        showNowmonth: true,
        defaulttabname: "subtractnum",
        showtab: 1,
        checkXL:false,
        dialogFormVisible: false,
        initContent: [],
        initContentLeft: [],
        initContentRight: [],
        tableDataYinxin:[],
        yinxintotalnumber:0,
        showOrderDetail:true,
        xcolumn: [],
        ycolumn: [],
        RorL: '',
        minyear: yearnow,
        minmonth: monthnow,
        maxyear: yearnow,
        maxmonth: monthnow,
        seedcode: "",
        seedname: "",
        cangkucode: "",
        cangkuname: "",
        Y: '',//球镜
        X: '',//柱镜
        jxcstoreData: [],
        monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        tableData: [],
        tableData2: [],//出入库明细
        tableStoreDetail: [],
        deliverData: [],//待发货
        text: [],
        filltemplate: "",
        showzuoyoutable: false,
        showerweitable: false,
        qichu: 0,
        isjingjia: false,
      }
    },
    methods: {
      tableRowClassName({row, rowIndex}) {
        var date = new Date();
        if (new Date(row.endtime) < date) {
          return 'error-row';
        } else {
          date.setMonth(date.getMonth() + 14);
          console.log(date)
          if (new Date(row.endtime) < date) {
            return 'warning-row';
          }
        }
        return '';
      },
      handle(row, event, column) {
        this.$refs.UniqueCode.show()
        this.$refs.UniqueCode.initData(this.cangkucode, this.cangkuname, this.seedcode, this.seedname)
      },
      checkNow() {
        this.showNowmonth = (this.minyear == new Date().getFullYear() &&
          this.minmonth == new Date().getMonth() + 1);
      },
      scancode() {
        this.$refs.UniqueCode.show()
      },
      print1() {
        if (this.filltemplate == 40) {
          this.$nextTick(() => {
            this.$print(this.$refs.print1)
          })
        } else {
          this.tableData = []
          var startDate = new Date(this.title.replace('）', '').substr(6).split('~')[0]);
          var endDate = new Date(this.title.replace('）', '').substr(6).split('~')[1]);

          var data = {
            begindate: startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + "-" + startDate.getDate(),
            enddate: endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + "-" + endDate.getDate(),
            seedname: this.seedname,
            seedcode: this.seedcode,
            filltemplate: this.filltemplate,
            initContent: this.initContent,
            initContentLeft: this.initContentLeft,
            initContentRight: this.initContentRight,
            businessType: 'kucunExport',
          }
          exportPdf(data)

        }

      },
      getSummaries(param) {
        var qichu = 0, debitnum = 0, creditnum = 0, subtractnum = 0, deliverying = 0, transfernum = 0, setminstore = 0, canuse = 0,minstore = 0,setmaxstore = 0, maxstore = 0, surplus = 0;
        const {columns, data} = param;
        data.forEach((column, index) => {

          qichu += column.qichu
          debitnum += column.debitnum
          creditnum += column.creditnum
          subtractnum += column.subtractnum
          deliverying += column.deliverying
          canuse += column.canuse;
          transfernum += column.transfernum
          setminstore += column.setminstore
          minstore += column.minstore
          setmaxstore += column.setmaxstore
          maxstore += column.maxstore
          surplus += column.surplus

        });
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总价';
            return;
          }
          switch (column.label) {
            case '期初':
              sums.push(this.$numeric(qichu, 0))
              break;
            case '入库':
              sums.push(this.$numeric(debitnum, 0))
              break;
            case '出库':
              sums.push(this.$numeric(creditnum, 0))
              break;
            case '结存':
              sums.push(this.$numeric(subtractnum, 0))
              break;
            case '待发货':
              sums.push(this.$numeric(deliverying, 0))
              break;
            case '可用量':
              sums.push(this.$numeric(canuse, 0))
              break;
            case '调拨中':
              sums.push(this.$numeric(transfernum, 0))
              break;
            case '最小库存':
              sums.push(this.$numeric(setminstore, 0))
              break;
            case '预警':
              sums.push(this.$numeric(minstore, 0))
              break;
            case '最大库存':
              sums.push(this.$numeric(setmaxstore, 0))
              break;
            case '需补货':
              sums.push(this.$numeric(maxstore, 0))
              break;
            case '超库存':
              sums.push(this.$numeric(surplus, 0))
              break;
            default:
              sums.push("")
              break;
          }

        });
        return sums;
      },
      ceshi() {

      },
      lookMachiningCopy(row) {
        this.$refs.machiningeditcopy.initData(row)
        this.$refs.machiningeditcopy.show()
      },

      lookDetailsCopy(row) {
        this.$refs.DataContactEditCopy.initData(row)
        this.$refs.DataContactEditCopy.show()
      },
      lookorder(row) {
        if (row.ordernum) {
          var s = {
            erpserial: row.ordernum
          }
        } else {
          var s = {
            erpserial: row.erpserial
          }
        }

        if (row.ordername == '调拨入库' || row.ordername == '调拨出库') {
          this.$refs.AllocationDetail.initData(s)
          this.$refs.AllocationDetail.show()
        } else if (row.ordername == '采购入库') {
          this.$refs.BuyorderDetail.initData(row, 1)
          this.$refs.BuyorderDetail.show();
        } else if (row.ordername == '坏件库转入') {
          this.$refs.StorageBadOut.show(row.ordernum)
        } else if (row.erpformname == '盘点单') {
            this.$refs.MakeInventoryEdit.initData(s)
        } else if (row.ordername == '报损出库'||row.ordername == '转坏件库') {
          this.$refs.BaoSunDetail.show(row.ordernum)
        } else if (this.filltemplate == "50") {
          this.$refs.machiningedit.initData(s)
          this.$refs.machiningedit.show()
        } else {
          this.$refs.DataContactEdit.initData(s)
          this.$refs.DataContactEdit.show()
        }
      },
      tip() {
        if (this.showtab == 2) {
          return true
        }
        return false
      },
      change1(value) {
        this.Y = value
        this.initStoreDetail()
      },
      change2(value) {
        this.X = value
        this.initStoreDetail()
      },
      zhixiaolen(){
        var obj = {}
        obj.seedcode = this.seedcode
        obj.seedname =this.seedname
        obj.cangkucode = this.cangkucode
        obj.filltemplate = this.filltemplate
        obj.initContent = this.initContent
        this.$refs.zhixiaolen.show(obj)
      },
      //智能库存
      zhinengstock() {
        var obj = {}
        obj.seedcode = this.seedcode
        obj.seedname = this.seedname
        obj.cangkucode = this.cangkucode
        obj.filltemplate = this.filltemplate
        this.$refs.zhinengstock.show(obj)
      },
      exportExcel(val) {
        if (this.showtab == 3) {
          //#region
          let data = []
          for (let i in this.tableData) {
            data.push(Object.assign({}, this.tableData[i]))
          }
          for (let i = 0; i < data.length; i++) {
            data[i]['seedcode'] = this.seedcode
            for (let j in data[i]) {
              data[i][j] = data[i][j] == 0 ? "" : data[i][j]
            }
            var ps = JSON.parse(data[i]['packagesize']);
            if (ps.M) {
              data[i]['packagesize'] = ps.M + '-' + ps.C;
            } else
              data[i]['packagesize'] = 'S：' + ps.Y + ' ， C：' + ps.X;
          }

          let header1 = ["编码", "规格", "期初", "入库", "出库", "结存","待发货","可用量", "调拨中", "最小库存", "预警", "最大库存", "需补货", "超库存"]
          let column1 = ["seedcode", "packagesize", "qichu", "debitnum", "creditnum", "subtractnum","deliverying","canuse", "transfernum", "setminstore", "minstore", "setmaxstore", "maxstore", "surplus"]
          let name = this.cangkuname + this.minyear + '' + this.minmonth + this.seedname//+ '至' + this.maxyear + this.maxmonth
          this.$exportExcel(header1, column1, data, name)
          //#endregion
        }else if(this.showtab ==2){
          //#region 出入库明细
          let data = []
          for (let i in this.tableData2) {
            data.push(Object.assign({}, this.tableData2[i]))
          }
          for (let i = 0; i < data.length; i++) {
            if (!data[i]['ordernum'])
              data[i]['ordernum'] = data[i]['erpserial'];
            if (!data[i]['ordername'])
              data[i]['ordername'] = data[i]['erpformname']
            if (data[i]['packagesize']) {
              var ps = JSON.parse(data[i]['packagesize']);
              data[i]['Y'] = ps.Y;
              data[i]['X'] = ps.X;
            }
          }

          let header1 = ["日期", "订单号", "单据类型", "球镜", "柱镜", "入库", "出库","结存"];
          let column1 = ["accdate","ordernum", "ordername","Y", "X", "debitnum", "creditnum", "subtractnum"];
          let name = "出入库明细 "+this.cangkuname + this.minyear + '' + this.minmonth + this.seedname;
          this.$exportExcel(header1, column1, data, name);
          //#endregion
        }else if(this.showtab ==4){
          //#region 待发货订单
          let data = []
          for (let i in this.deliverData) {
            data.push(Object.assign({}, this.deliverData[i]))
          }
          for (let i = 0; i < data.length; i++) {
            if (data[i]['packagesize']) {
              var ps = JSON.parse(data[i]['packagesize']);
              data[i]['Y'] = ps.Y;
              data[i]['X'] = ps.X;
            }
          }

          let header1 = ["日期", "订单号", "门店", "球镜", "柱镜","数量"];
          let column1 = ["htqd","erpserial", "customername","Y", "X", "deliverying"];
          let name = "待发货订单 "+this.cangkuname + this.minyear + '' + this.minmonth + this.seedname;
          this.$exportExcel(header1, column1, data, name);
          //#endregion
        } else {
          //#region
          this.xcolumn = []
          this.ycolumn = []
          var content = this.initContent
          var firstTitle='球\\柱';
          if(this.filltemplate==80){
            firstTitle='型\\规';
            content.forEach(o => {
              let temp1 = this.xcolumn.filter(item => {
                return item == o.C
              })
              if (temp1.length == 0) {
                this.xcolumn.push(o.C)
              }
              let temp2 = this.ycolumn.filter(item => {
                return item == o.M
              })
              if (temp2.length == 0) {
                this.ycolumn.push(o.M)
              }
            })
            this.xcolumn.sort(this.sequence)
            this.xcolumn.unshift(firstTitle)
            this.xcolumn.push("合计")
            this.ycolumn.sort(this.sequence)

          }else {
            content.forEach(o => {
              console.log(o)
              let temp1 = this.xcolumn.filter(item => {
                return item == o.X
              })
              if (temp1.length == 0) {
                this.xcolumn.push(parseFloat(o.X).toFixed(2))
              }
              let temp2 = this.ycolumn.filter(item => {
                return item == o.Y
              })
              if (temp2.length == 0) {
                this.ycolumn.push(parseFloat(o.Y).toFixed(2))
              }
            })
            this.xcolumn.sort((a, b) => {
              return parseFloat(b) - parseFloat(a)
            })
            this.xcolumn.unshift(firstTitle)
            this.xcolumn.push("合计")
            this.ycolumn.sort((a, b) => {
              return parseFloat(b) - parseFloat(a)
            })
          }
          //下面按照格式拼接
          let data = [] //导出的数据,
          console.log(content)
          this.ycolumn.forEach(y => {
            let heji = 0;
            let temp1 = {}
            temp1[firstTitle] = this.filltemplate==80?y:(parseFloat(y) > 0 ? ("+" + y) : y);
            this.xcolumn.forEach(x => {
              for (let i in content) {
                if ((this.filltemplate==80&&content[i].C == x && content[i].M == y)||
                  (this.filltemplate!=80&&parseFloat(content[i].X) == parseFloat(x) && parseFloat(content[i].Y) == parseFloat(y))) {
                  temp1[x] = content[i].P
                  console.log(temp1[x])
                  if (Number(content[i].P))
                    heji += content[i].P
                  break;
                }
              }
            })
            temp1['合计'] = heji
            data.push(temp1)
          })
          //导出合计计算
          var hj = {}
          hj[firstTitle]="合计";

          var zhj = 0;
          this.xcolumn.forEach(x => {
            if (x != firstTitle && x != "合计") {
              hj[x] = 0
              data.forEach(item => {
                if (Number(item[x])) {
                  hj[x] = hj[x] + item[x]
                }
              })
              zhj += hj[x]
            }
            //计算总合计
            if (x == "合计") {
              hj[x] = zhj
            }
          })
          data.push(hj)
          let title = "【" + this.seedcode + "】" + this.seedname + "【" + this.minyear + "-" + this.minmonth + "】"

          var biaoti = []
          let header1 =this.filltemplate==80?this.xcolumn: this.xcolumn.map(item => parseFloat(item) > 0 ? "+" + item : item)
          biaoti.push(this.seedcode)
          biaoti.push(this.seedname)
          biaoti.push(formatTimeToStr(new Date()))
          if (this.filltemplate == 30) {
            var dataexcel = {
              initContentLeft: JSON.stringify(this.initContentLeft),
              initContentRight: JSON.stringify(this.initContentRight),
              seedcode: this.seedcode,
              seedname: this.seedname,
              businessType: 'inventoryDetails'
            }
            exportExcel(dataexcel)
          } else {
            this.$exportExcel(header1, this.xcolumn, data, title, biaoti)
          }
          //#endregion
        }

      },
      sequence(a, b) {//从小到大排列
        if (a > b) {
          return 1;
        } else if (a < b) {
          return -1
        } else {
          return 0;
        }
      },
      getPackagesize(Packagesize,col) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        return JSON.parse(Packagesize)[col];
        // var rl = '';
        // if (ps.type)
        //   rl = ps.type + '，';
        //
        // return rl + 'S：' + ps.Y + ' ， C：' + ps.X;
      }
      ,
      tabClick(tab, event) {
        this.showtab = 0;
        this.currentcomponent = "";
        this.defaulttabname = tab.name;
        if (this.defaulttabname == 'storedetail') {
          this.showtab = 2;//出入库明细的Table 待补充
          //this.bindDetail();
        } else if (this.defaulttabname == 'sublist') {
          this.showtab = 3;
        } else if (this.defaulttabname == 'deliverying') {
          this.showtab = 4;
          this.stayDeliver();//待发货
        } else {
          this.showtab = 1;
          this.bindTwoDimens();
        }
      }
      ,

      bindTwoDimens() {
        this.initContent = []
        this.initContentLeft = []
        this.initContentRight = []
        if (this.showtab == 1) {
          this.showtab = 0;
          for (let j in this.tableData) {
            if (this.tableData[j].packagesize && this.tableData[j].packagesize != '') {
              var ps = JSON.parse(this.tableData[j].packagesize);
              var P = this.tableData[j][this.defaulttabname];
              ps.maxnum=this.tableData[j]['setmaxstore'];
              // if (P && P != 0) {
              // let o = {"X": Number(ps.X), "Y": Number(ps.Y), "P": Number(P)}
              if (!P || P == 0) {
                P = ''
              }
              ps.P = P
              if (this.filltemplate == "30") {//左右眼
                if (ps.type == "L")
                  this.initContentLeft.push(ps)
                else
                  this.initContentRight.push(ps)
              } else {
                this.initContent.push(ps);
              }
              // }
            }
          }

          if (this.filltemplate == 80) {
            this.currentcomponent = "glassFrameView";
          } else {
            this.currentcomponent = "TwoDimensionalView";
          }
          this.$nextTick(() => {
            this.showtab = 1;
          })
        }
      }
      ,
      //待发货
      stayDeliver() {
        stayDelivar({
          seedcode: this.seedcode,
          cangkucode: this.cangkucode,
          maxyear: this.minyear,
          maxmonth: this.minmonth,
        }).then(response => {
          this.deliverData = response.data.obj;
        })
      }
      ,
      initStoreDetail()//过滤出入库明细
      {
        //1、获取期初
        var existSearch = this.Y || this.X || this.RorL;
        var qichu = 0, debit = 0, credit = 0;

        this.tableData.forEach(o => {
          if (existSearch && o.packagesize) {
            var packagesize = JSON.parse(o.packagesize)
            if (packagesize.M) {
              if ((this.Y && packagesize['M'] != this.Y) ||
                (this.X && packagesize['C'] != this.X)) {

              } else {
                qichu += o.qichu
              }
            } else {
              if ((this.Y && parseFloat(packagesize['Y']) != parseFloat(this.Y)) ||
                (this.X && parseFloat(packagesize['X']) != parseFloat(this.X)) ||
                (this.RorL && packagesize['type'] != this.RorL)) {

              } else {
                qichu += o.qichu
              }
            }
          } else {
            qichu += o.qichu
          }
        })

        this.tableData2 = []
        this.tableStoreDetail.forEach(o => {
          if (o.ordernum == '期初余额' || o.ordernum == '合计') {
            if (o.ordernum == '合计') {
              o.debitnum = debit;
              o.creditnum = credit;
            }
            o.subtractnum = qichu;
            this.tableData2.push(o);
          }
          else {
            if (existSearch && o.packagesize) {
              var packagesize = JSON.parse(o.packagesize)
              var needAdd = false;
              if (packagesize.M) {
                if ((this.Y && packagesize['M'] != this.Y) ||
                  (this.X && packagesize['C'] != this.X) ) {

                } else {
                  needAdd = true;
                }
              }else {
                if ((this.Y && parseFloat(packagesize['Y']) != parseFloat(this.Y)) ||
                  (this.X && parseFloat(packagesize['X']) != parseFloat(this.X)) ||
                  (this.RorL && packagesize['type'] != this.RorL)) {

                } else {
                  needAdd = true;
                }
              }

              if (needAdd) {
                debit += o.debitnum | 0;
                credit += o.creditnum | 0;
                qichu += (o.debitnum | 0) - (o.creditnum | 0);
                o.subtractnum = qichu;
                this.tableData2.push(o);
              }
            } else {
              debit += o.debitnum | 0;
              credit += o.creditnum | 0;
              qichu += (o.debitnum | 0) - (o.creditnum | 0);
              o.subtractnum = qichu;
              this.tableData2.push(o);
            }
          }
        })
      },
      //出入库明细
      bindDetail() {
        getStoreFormList({
          seedcode: this.seedcode,//产品分类（单选）
          cangkucode: this.cangkucode,//选择的仓库（单选）
          minyear: this.minyear,
          minmonth: this.minmonth,
          maxyear: this.minyear,
          maxmonth: this.minmonth,
          nostock: 1,
          allxili: this.checkXL ? 1 : -1,
          showyinxing: this.showyinxing ? 1 : -1
        }).then(response => {
          if (response.data.code == 0) {
            this.tableStoreDetail = response.data.obj

            //补上已销售明细
            for (let p in this.tableData) {
              if (!this.tableData[p].hassale)
                this.tableData[p].hassale = 0;

              for (let i in this.tableStoreDetail) {
                if (this.tableStoreDetail[i].ordername == '销货单'
                  && this.tableStoreDetail[i].packagesize == this.tableData[p].packagesize) {
                  this.tableData[p].hassale += this.tableStoreDetail[i].creditnum;
                }
              }
            }

            this.initStoreDetail();
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        }).catch((error) => {
          console.log(error)
        });
      }
      ,
      bindTree() {//绑定树控件
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1})
        })
      }
      ,
      checktree(guids, names, arr) {
        this.seedcode = guids
        this.seedname = names
        this.showzuoyoutable = false
        this.showerweitable = false
        this.filltemplate = arr[0].attributes.filltemplate
        this.controlerweitableview()
      }
      ,
      controlerweitableview() {//控制左右眼二维表
        if (this.filltemplate == '30') {//左右眼
          this.showzuoyoutable = true
          this.showerweitable = false
        } else {
          this.showzuoyoutable = false
          this.showerweitable = true
        }
      }
      ,
      search() {
        this.defaulttabname = 'subtractnum'
        this.bindGrid();
      }
      ,
      initData(row, minyear, minmonth, maxyear, maxmonth) {
        this.tableData2 = []
        this.tableData = []
        this.deliverData = []
        this.xcolumn = []
        this.ycolumn = []
        this.minyear = minyear;
        this.minmonth = minmonth;
        this.maxyear = minyear;
        this.maxmonth = minmonth;
        this.filltemplate = row.filltemplate
        this.cangkucode = row.cangkucode
        this.showOrderDetail=false;
        for(let i in this.jxcstoreData){
          if(this.jxcstoreData[i].cangkucode==this.cangkucode){
            this.showOrderDetail=true;
            break;
          }
        }
        this.cangkuname = row.cangkuname
        this.seedcode = row.seedcode
        this.seedname =row.cangkuname+' '+ row.seedname
        this.controlerweitableview()
        this.dialogFormVisible = true
        this.Y = ''
        this.X = ''
        this.RorL = ''
        this.defaulttabname = "subtractnum";//当前库存
        this.showtab = 1
        this.bindGrid();
      },
      setCanUse(row) {
        row.canuse = (row.subtractnum ? row.subtractnum : 0) - (row.deliverying ? row.deliverying : 0);
      },
      bindGrid() {
        this.checkNow();
        this.tableDataYinxin=[]
        this.yinxintotalnumber=0;
        getGoodsListWithStoreDetail({
          seedcode: this.seedcode,//产品分类（单选）
          cangkucode: this.cangkucode,//选择的仓库（单选）
          minyear: this.minyear,
          minmonth: this.minmonth,
          maxyear: this.minyear,
          maxmonth: this.minmonth,
          nostock: 1,
          allxili:this.checkXL?1:-1
        }).then(response => {
          this.tableData = response.data.obj;
          for(let i in this.tableData){
            this.setCanUse(this.tableData[i]);
          }
          if(this.filltemplate==80) {
            this.tableData.sort(function (a, b) {
              var pA =a.packagesize? JSON.parse(a.packagesize):{"M":"","C":""}
              var pB =b.packagesize? JSON.parse(b.packagesize):{"M":"","C":""}

              if (pA.M == pB.M)
                return pA.C.localeCompare(pB.C)
              else
                return pA.M.localeCompare(pB.M)
            })
          }
          if(this.showyinxing) {//隐形批次
            listBarchnoSub({cangkucode: this.cangkucode, seedcode: this.seedcode, allnumber: '1'}).then(resBarch => {
              this.tableDataYinxin = resBarch.data.obj.sort(function (a, b) {
                var pA =a.packagesize? JSON.parse(a.packagesize):{"X":"0","Y":"0"}
                var pB =b.packagesize? JSON.parse(b.packagesize):{"X":"0","Y":"0"}
                if (pA.X == pB.X) {
                  if(pA.Y=='0.00') pA.Y="-0.00";
                  if(pB.Y=='0.00') pB.Y="-0.00";
                  return pA.Y.localeCompare(pB.Y)
                }
                else {
                  if(pA.X=='0.00') pA.X="-0.00";
                  if(pB.X=='0.00') pB.X="-0.00";
                  return pA.X.localeCompare(pB.X)
                }
              });
              for(let i in this.tableDataYinxin){
                this.yinxintotalnumber+=this.tableDataYinxin[i].totalnumber;
              }
            });
          }

          this.showerb = true;
          if (this.tableData.length > 0 && (!this.tableData[0].packagesize || this.tableData[0].packagesize == '')) {
            this.showerb = false;
          }
          if (this.showtab == 1)
            this.bindTwoDimens();

          this.bindDetail();

          if (this.defaulttabname == 'deliverying')
            this.stayDeliver();//待发货
        }).catch((error) => {
          console.log(error)
        });
      }
      ,
      getYearList() {
        var arr = [];
        var yearnow = new Date().getFullYear();
        for (let i = yearnow; i >= 2022; i--) {
          arr.push(i)
        }
        return arr
      }
    },
    props:{
      showyinxing:false,
    },
    watch: {}
    ,
    mounted() {
      cusandptbyind({}).then(response => {
        this.jxcstoreData = response.data.obj
      })
    }
    ,
    components: {
      TwoDimensionalView,
      glassFrameView,
      CstagreementMachiningEdit,
      CstagreementEdit,
      AllocationDetail,
      BuyorderDetail,
      MakeInventorySwitch,
      StorageBadOut,
      BaoSunDetail,
      UniqueCode,
      zhixiaolen,
      zhinengstock
    }
    ,
  }
</script>

<style scoped>
  .erweitable td {
    border: 1px solid #E0DFDF;
    min-width: 80px;
    max-width: 100px;
    text-align: center;
    vertical-align: center;
  }

  .erweitable .content {
    border: none;
    padding: 1px;
  }

</style>

<style>
  .el-table .error-row {
    background: #F56C6C;
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/warehouse/StorageView.vue